export default "__VITE_ASSET__6OHPilqq__"